export default __webpack_public_path__ + "static/media/pic11-1.cc1bd039.jpg";